<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-button type="primary" @click="pageChange(1)" size="mini">搜索</el-button>
      <el-input v-model="query.name" placeholder="供应商名称" style="width:200px" size="mini" @change="pageChange(1)" clearable />
      <el-input v-model="query.yy_code" placeholder="用友编号" style="width:200px" size="mini" @change="pageChange(1)" clearable />
      <el-select size="mini" placeholder="主体性质" v-model="query.entity_type" @change="pageChange(1)" clearable>
        <el-option label="企业" value="COMPANY"></el-option>
        <el-option label="个人" value="PERSON"></el-option>
      </el-select>
      <el-select size="mini" placeholder="证件类型" v-model="query.id_type" @change="pageChange(1)" clearable>
        <el-option label="身份证" value="IDENTITY_CARD"></el-option>
        <el-option label="护照" value="PASSPORT"></el-option>
      </el-select>
      <el-select size="mini" placeholder="状态" v-model="query.enabled" @change="pageChange(1)" clearable>
        <el-option label="启用" value="1"></el-option>
        <el-option label="禁用" value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="handleAdd" size="mini">新增</el-button>
      <el-button type="primary" @click="openExcel" size="mini">导出</el-button>
    </div>

    <!--
    CREATE TABLE `sp_suppliers` (
      `id` int(11) NOT NULL AUTO_INCREMENT,
      `name` varchar(100) DEFAULT NULL COMMENT '供应商名称',
      `yy_code` varchar(100) DEFAULT NULL COMMENT '用友编码',
      `entity_type` varchar(20) DEFAULT NULL COMMENT '主体性质：COMPANY（企业）/ PERSON（个人）',
      `id_type` varchar(30) DEFAULT NULL COMMENT '证件类型，同员工',
      `id_no` varchar(30) DEFAULT NULL COMMENT '证件号码',
      `enabled` tinyint(1) DEFAULT '1' COMMENT '状态：1=启用（默认），0=禁用',
      `create_time` datetime DEFAULT NULL,
      `update_time` datetime DEFAULT NULL,
      PRIMARY KEY (`id`),
      KEY `name` (`name`),
      KEY `yy_code` (`yy_code`),
      KEY `entity_type` (`entity_type`)
    ) ENGINE=InnoDB AUTO_INCREMENT=6736 DEFAULT CHARSET=utf8 COMMENT='供应商';
    -->

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="供应商名称" min-width="250" />
      <el-table-column prop="yy_code" label="用友编码" width="100" />
      <el-table-column prop="entity_type" label="主体性质" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.entity_type === 'COMPANY'">企业</el-tag>
          <el-tag v-else>个人</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="id_type" label="证件类型" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.id_type === 'IDENTITY_CARD'">身份证</el-tag>
          <el-tag v-else>护照</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="id_no" label="证件号码" width="200" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row.id)">编辑</el-button>
<!--          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="dialogVisible" title="用户信息" width="500px">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="供应商名称">
          <el-input v-model="form.name" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="用友编码">
          <el-input v-model="form.yy_code" placeholder="系统主动生成" size="mini" disabled />
        </el-descriptions-item>
        <el-descriptions-item label="主体性质">
          <el-select v-model="form.entity_type" placeholder="请选择" size="mini">
            <el-option label="企业" value="COMPANY"></el-option>
            <el-option label="个人" value="PERSON"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="证件类型">
          <el-select v-model="form.id_type" placeholder="请选择" size="mini">
            <el-option label="身份证" value="IDENTITY_CARD"></el-option>
            <el-option label="护照" value="PASSPORT"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="证件号码">
          <el-input v-model="form.id_no" placeholder="请输入" size="mini" />
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用" :active-value="1" :inactive-value="0" size="mini"></el-switch>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'Suppliers',
  data() {
    return {
      query: {
        name: "",
        yy_code: "",
        entity_type: "",
        id_type: "",
        enabled: "",
      },
      pageData:{
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {
        id: 0,
        name: "",
        yy_code: "",
        entity_type: "",
        id_type: "",
        id_no: "",
        enabled: 1,
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // ====================== 获取列表 ======================
    getList() {
      const params = Params.ins()
        .where(this.query.name ? ['name', 'like', '%' + this.query.name + '%'] : null)
        .where(this.query.yy_code ? ['yy_code', '=', this.query.yy_code] : null)
        .where(this.query.entity_type ? ['entity_type', '=', this.query.entity_type] : null)
        .where(this.query.id_type ? ['id_type', '=', this.query.id_type] : null)
        .where(this.query.id_no ? ['id_no', '=', this.query.id_no] : null)
        .where(this.query.enabled ? ['enabled', '=', this.query.enabled] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('Suppliers/index', params, res => {
        if(res.code===200){
          this.pageData = res.data
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },

    // 新增
    handleAdd() {
      this.form = {
        id: 0,
        name: "",
        yy_code: "",
        entity_type: "",
        id_type: "",
        id_no: "",
        enabled: 1,
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(id) {
      Http.post('Suppliers/detail', Params.ins().detail(id), res => {
        if(res.code===200){
          this.form = res.data
          this.dialogVisible = true
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 提交保存
    submit() {
      if (!this.form.id) {
        this.form.id = 0
      }

      Http.post('Suppliers/save', Params.ins().save(this.form), res => {
        if(res.code===200){
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getList()
        }else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    // 删除
    handleDelete(id) {
      const that=this;
      that.$confirm('确定删除？').then( () => {

        Http.post('Suppliers/delete', Params.ins().delete(id), res => {
          if(res.code===200){
            this.$message.success('删除成功')
            this.getList()
          }else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })

      })
    },
    openExcel() {
      window.open("https://test.usercenter.gdzawy.com/taskPoolPhp/accounting/Suppliers/exportExcel")
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body{
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/FinancialCenter/Suppliers.vue